import { render, staticRenderFns } from "./BadgeCustom.vue?vue&type=template&id=412cf6f9&scoped=true&"
import script from "./BadgeCustom.vue?vue&type=script&lang=js&"
export * from "./BadgeCustom.vue?vue&type=script&lang=js&"
import style0 from "./BadgeCustom.vue?vue&type=style&index=0&id=412cf6f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412cf6f9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAvatar,VList,VListItem,VListItemTitle,VMenu,VToolbarItems})
